const name = 'circle-0';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M30.707 26.5c1.933 0 3.604.373 5.012 1.119a9.642 9.642 0 013.48 3.107c.912 1.325 1.589 2.858 2.03 4.598.442 1.74.663 3.605.663 5.593 0 1.989-.22 3.867-.663 5.634-.441 1.768-1.118 3.315-2.03 4.64a10.018 10.018 0 01-3.48 3.149c-1.408.773-3.08 1.16-5.012 1.16-1.934 0-3.605-.387-5.013-1.16a10.018 10.018 0 01-3.48-3.149c-.912-1.325-1.588-2.872-2.03-4.64-.442-1.767-.663-3.645-.663-5.634 0-1.988.22-3.853.663-5.593.442-1.74 1.118-3.273 2.03-4.598a9.642 9.642 0 013.48-3.107c1.408-.746 3.08-1.119 5.013-1.119zm4.937 9.234l-7.665 14.37c.736.512 1.638.768 2.705.768 2.044 0 3.48-.939 4.308-2.817.829-1.878 1.243-4.253 1.243-7.126 0-1.981-.197-3.713-.591-5.195zm-4.953-4.582c-2.044 0-3.48.912-4.309 2.734-.828 1.823-1.242 4.17-1.242 7.043 0 2.113.224 3.956.672 5.531l.012-.004 7.711-14.46c-.76-.563-1.708-.844-2.844-.844z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '0',
};

export default icon;
